import React from "react"
import DatasetDetail from "@/components/DatasetDetail"
import { Flex } from "@chakra-ui/react"

export default function DatasetDetailView() {
  return (
    <Flex direction="column" flexGrow={1} minHeight={0} width="100%">
      <DatasetDetail />
    </Flex>
  )
}
